import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import './NotFound.css';

/**
 * Rendered for any URL that does not match a route.
 *
 * Apache (public/.htaccess) returns a real HTTP 404 for unknown top-level
 * paths, so this component mainly covers deep paths under a known section
 * (e.g. /products/does-not-exist). Because those are still served with a 200
 * by the SPA fallback, we inject a noindex tag so Google never indexes them.
 */
function NotFound() {
    useEffect(() => {
        window.scrollTo(0, 0);

        const meta = document.createElement('meta');
        meta.name = 'robots';
        meta.content = 'noindex, follow';
        document.head.appendChild(meta);

        return () => {
            document.head.removeChild(meta);
        };
    }, []);

    return (
        <Container className="not-found-page">
            <p className="not-found-code">404</p>
            <h1 className="not-found-title">This page could not be found</h1>
            <p className="not-found-text">
                The page you are looking for may have moved, or the address may have been
                mistyped. Our website structure changed recently, so an old bookmark may
                need updating.
            </p>

            <div className="not-found-links">
                <Link className="not-found-primary" to="/">Back to the homepage</Link>
            </div>

            <h2 className="not-found-subtitle">Popular sections</h2>
            <ul className="not-found-list">
                <li><Link to="/products">Products</Link> &mdash; hoses, fittings, pipelines and drive technology</li>
                <li><Link to="/services">Services</Link> &mdash; mobile service, maintenance, repair and engineering</li>
                <li><Link to="/services/mobile-rapid-hydraulic-service">Mobile Rapid Hydraulic Service</Link> &mdash; 24/7 breakdown response</li>
                <li><Link to="/about/who-we-are">About HANSA-FLEX Ireland</Link></li>
                <li><Link to="/contact-us">Contact us</Link></li>
            </ul>
        </Container>
    );
}

export default NotFound;
